
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trainers",
      function () {
        return require("private-next-pages/trainers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trainers"])
      });
    }
  